import { gql } from "@apollo/client";

export default gql`
  mutation deleteStock($_id: String) {
    deleteStock(_id: $_id) {
      ok
      message
      error
    }
  }
`;
